import { motion } from "framer-motion";
import { PartyPopper } from "lucide-react";
import { content } from "../../data/content";
import { rainConfetti } from "../../lib/confetti";
import { Reveal } from "./Reveal";

export function Footer() {
  return (
    <footer
      data-testid="footer-section"
      className="relative w-full bg-rose text-white px-5 md:px-10 py-24 md:py-32 flex flex-col items-center text-center overflow-hidden"
    >
      <Reveal>
        <h2 className="font-heading font-black uppercase tracking-tighter text-5xl md:text-8xl leading-[0.9] mb-10">
          Feliz cumple,
          <br />
          <span className="text-butter">{content.recipientFirst}</span>
        </h2>
      </Reveal>

      <motion.button
        data-testid="confetti-button"
        onClick={rainConfetti}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.94 }}
        className="inline-flex items-center gap-3 rounded-full bg-white text-ink font-body font-extrabold px-8 py-5 text-lg md:text-2xl shadow-brutal-lg border-[3px] border-ink"
      >
        <PartyPopper className="w-6 h-6 md:w-8 md:h-8 text-rose" />
        {content.footerCta}
      </motion.button>

      <div className="mt-16 font-body font-semibold text-white/80">
        Hecho con mucho cariño por {content.sender}
      </div>
    </footer>
  );
}
